import jbAPI from "./jobboard";

console.log("applyNow api ");

export const applyNow = async (job_id, job_seeker_id, token, cover_letter = "") => {
  try {
    const response = await jbAPI.post(
      `/jobs/${job_id}/apply`,
      { job_seeker_id, cover_letter },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to apply for job:", error);
    throw error;
  }
};

export const getAppliedJobs = async (job_seeker_id, token) => {
  try {
    const response = await jbAPI.get(`/jobs/applied/${job_seeker_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.appliedJobs;
  } catch (error) {
    console.error("Failed to fetch applied jobs:", error);
    return [];
  }
};
